<template>
  <!-- 我的提报 -->
    <div class="user_container">
      <div class="goback">
        <div @click="goback">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
        <div class="goback_search">
          <el-input
            v-model="searchValue"
            placeholder="请输入..."
            @input="search"
          ></el-input>
          <i class="el-icon-search"></i>
        </div>
      </div>
      <div class="detail_title_info">
        <van-tabs v-model="active" @change="tabChange" v-if="isHR == '1'">
          <van-tab title="个人汇总">
            <list
              ref="list"
              v-if="active == 0"
              :type="type"
              :searchValue="searchValue"
            ></list>
          </van-tab>
          <van-tab title="HR汇总">
            <list
              ref="list2"
              v-if="active == 1"
              :type="type"
              :searchValue="searchValue"
              :newText="newText"
            ></list>
          </van-tab>
        </van-tabs>
  
        <list ref="list" v-else></list>
        <div class="pick" v-if="active == 1">
          <div class="newDate" @click="showPickText = true">
            {{ newText }}
          </div>
          <i class="el-icon-arrow-down"></i>
          <van-popup v-model="showPickText" position="bottom">
            <van-picker
              show-toolbar
              :columns="columns"
              @confirm="onConfirmText"
              @cancel="showPickText = false"
            />
          </van-popup>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import list from "./list";
  import api from "@/apis/medal";
  export default {
    name: "detail",
    props: {},
    components: {
      list
    },
    data() {
      return {
        active: 0,
        type: "1",
        isHR: "",
        searchValue: "",
        newText: "全部",
        showPickText: false,
        columns: []
      };
    },
    created() {},
    mounted() {
      this.isHR = this.$route.query.isHR;
      this.queryList();
    },
    methods: {
      //获取搜索值
      search(val) {
        this.searchValue = val;
      },
      //tab切换
      tabChange(index) {
        this.searchValue = "";
        if (index == 0) {
          this.type = "1";
        } else {
          this.type = "2";
        }
      },
      //返回
      goback() {
        this.$router.go(-1);
      },
      //确认选择下拉框
      onConfirmText(value) {
        this.newText = value.text;
        // this.newValue = value.value;
        this.$refs.list2.getList();
        this.showPickText = false;
      },
      //获取提报列表
      queryList() {
        api.queryMedalTaskDetail({ type: "2", keyWord: "" }).then(data => {
          const list = data.data.filter(item => item.applyState == 2);
          const list1 = list.map(item => item.title);
  
          this.columns = [...new Set(list1)].map(item => {
            return {
              text: item,
              value: item
            };
          });
          this.newText = this.columns[0].text;
        });
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  $zoom: 1020 / 375;
  @media screen and (max-width: 600px) {
    .user_container {
      width: 100%;
    }
  }
  @media screen and (min-width: 600px) {
    .user_container {
      width: 276px * $zoom;
    }
  }
  .user_container {
    //   width: 100%;
    min-height: 100vh;
    padding: 30px 30px 0;
    // background: #fff;
    background: url("~@/assets/newMedal/bg2.png");
    background-size: 100% 100%;
    .detail_title_info {
      width: 100%;
      // height: 100%;
      position: relative;
    }
  }
  .goback {
    margin: 10px 0 40px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  
    div {
      display: flex;
      align-items: center;
    }
  
    i {
      font-weight: bold;
      font-size: 48px;
      margin-right: 40px;
    }
  
    span {
      font-size: 34px;
      flex-shrink: 0;
    }
  
    .goback_search {
      margin-left: 20px;
      display: flex;
      align-items: center;
      background: #fff;
      border-radius: 80px;
      height: 80px;
      // width: 58vw;
      padding: 0 30px 0 10px;
  
      align-items: center;
      justify-content: space-between;
  
      ::v-deep .el-input {
        flex: 1;
        height: 100%;
  
        &__inner {
          height: 100%;
          border: none;
          font-size: 28px;
          border-radius: 80px;
        }
      }
  
      i {
        font-size: 38px;
        margin-right: 10px !important;
      }
    }
  }
  ::v-deep {
    .van-tabs {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
    }
    .van-tabs__wrap {
      margin-bottom: 30px;
      height: 80px;
    }
    .van-tabs__content {
      flex: 1;
      overflow: auto;
    }
    .van-tab__pane {
      height: 100%;
    }
  }
  ::v-deep .van-tabs__nav {
    background: transparent;
    display: block;
    .van-tab {
      float: left;
      width: 200px;
      height: 100%;
      font-size: 32px;
      line-height: 66px;
      color: #969b9e;
    }
    .van-tab--active {
      color: #1fbe8a;
      background: #fff;
      box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.07);
      border-radius: 16px;
    }
    .van-tabs__line {
      width: 0;
      height: 0;
      // background: #4ea27c;
    }
  }
  .pick {
    position: absolute;
    top: 0;
    right: 0;
    width: 34%;
    height: 80px;
    border-radius: 80px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    margin-bottom: 15px;
    .newDate {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
    }
    div {
      color: #969b9e;
      font-size: 30px;
    }
    i {
      color: #969b9e;
    }
  }
  </style>
  